import type { AxiosRequestConfig } from 'axios';

const commonHeaders = {
  'Accept': 'application/json',
  'Content-Type': 'application/json',
  'X-Requested-With': 'XMLHttpRequest',
} as const;

export const getBaseRequestConfig = (): AxiosRequestConfig =>
  getRequestConfigWithHeaders({});

export const getRequestConfigWithHeaders = (additionalHeaders: Record<string, string>): AxiosRequestConfig => ({
  headers: { ...commonHeaders, ...additionalHeaders },
  withCredentials: true,
});
